import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class Voucher {
	id: number;
	code: string;
    amount: number;
    percentage: boolean;
    minimal_amount: number;
    active: boolean;
	valid_from: string;
	valid_from_date: NgbDateStruct;
	valid_to: string;
	valid_to_date: NgbDateStruct;
	one_time_use: boolean;
    shipping_discount: boolean;
	description_nl: string;
	description_en: string;
	description_fr: string;
	description_de: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/voucher.ts